import { render, staticRenderFns } from "./ThreatRow.vue?vue&type=template&id=264363e8&"
import script from "./ThreatRow.vue?vue&type=script&lang=js&"
export * from "./ThreatRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports